<template>
  <v-dialog v-model="dialog" width="1100px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $tc('label.anexo', 2) }}</span>
      </v-card-title>

      <v-card-text>
        <div v-if="gruposDoUsuario && gruposDoUsuario.length > 0">
          <v-expansion-panels v-model="painelAberto" multiple>
            <v-expansion-panel
              v-for="grupo in gruposDoUsuario"
              :key="grupo.id"
            >
              <v-expansion-panel-header>
                {{ grupo.id }} - {{ grupo.nome }}
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <list-files
                  :ref="`listFiles_${grupo.id}`" :uri="getUriParaGrupo(grupo.id)" :habilitar-exclusao="podeCadastrarAnexos"
                  :auto-load="false" colLg="4"
                  @ListFiles__arquivos="(files) => handleContagemArquivos(grupo.id, files.length)"
                >
                </list-files>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn id="cancel" color="primary darken-1" text @click.native="close">
          {{ $t('label.fechar') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListFiles from '@/shared-components/files/ListFiles';
import basePath from '@/common/functions/api-resource';

export default {
  name: 'UsuarioAnexosDialog',
  components: {
    ListFiles,
  },
  props: {
    podeVisualizarAnexos: Boolean,
    podeCadastrarAnexos: Boolean,
  },
  data() {
    return {
      dialog: false,
      usuario: null,
      gruposDoUsuario: [],
      painelAberto: [],
      contagemArquivos: {},
      loadedPanels: new Set(),
    };
  },
  methods: {
    open(usuario, gruposProcessados) {
      this.usuario = usuario;
      this.gruposDoUsuario = Array.isArray(gruposProcessados) ? gruposProcessados : [];
      this.painelAberto = [];
      this.contagemArquivos = {};
      this.loadedPanels.clear();
      this.dialog = true;

      this.$nextTick(() => {
        if (this.gruposDoUsuario.length > 0) {
          this.painelAberto = [0];
          this.loadDataForPanel(0);
        }
      });
    },

    close() {
      this.dialog = false;
      this.usuario = null;
      this.gruposDoUsuario = [];
      this.contagemArquivos = {};
      this.painelAberto = [];
      this.loadedPanels.clear();
    },

    getUriParaGrupo(idGrupoFornecedor) {
      const urlBase = basePath('job', 'arquivo/usuario');
      return this.usuario ? `${urlBase}/${this.usuario.id}/grupo-fornecedor/${idGrupoFornecedor}` : '';
    },

    handleContagemArquivos(idGrupo, quantidade) {
      this.$set(this.contagemArquivos, idGrupo, quantidade);
    },

    loadDataForPanel(index) {
      if (index !== null && index >= 0 && index < this.gruposDoUsuario.length && !this.loadedPanels.has(index)) {
        const grupo = this.gruposDoUsuario[index];
        const refName = `listFiles_${grupo.id}`;
        const listFilesComponent = this.$refs[refName];
        const componentInstance = Array.isArray(listFilesComponent) ? listFilesComponent[0] : listFilesComponent;
        if (componentInstance && typeof componentInstance.refresh === 'function') {
          componentInstance.refresh();
          this.loadedPanels.add(index);
        }
      }
    },
  },
  watch: {
    painelAberto(newIndices, oldIndices) {
      const currentOpen = Array.isArray(newIndices) ? newIndices : [];
      const previouslyOpen = Array.isArray(oldIndices) ? oldIndices : [];
      const justOpened = currentOpen.filter((index) => !previouslyOpen.includes(index));
      justOpened.forEach((index) => {
        this.loadDataForPanel(index);
      });
    },
  },
};
</script>
